import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { IconButton } from '@hotjar/hotsauce';
import { withHighlight } from '../withHighlight';
import { EventsBinding } from '../Controls/KeyboardShortcutEvents';

interface DeleteButtonProps {
  onClick: () => void;
  disabled: boolean;
}

const DeleteBtn = ({ onClick, disabled }: DeleteButtonProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <IconButton
      size="s"
      tooltipText={t('common:player.delete-recording')}
      description={t('common:player.delete-recording')}
      icon="trash"
      kind="ghost"
      onClick={onClick}
      isDisabled={disabled}
      data-testid="delete-recording"
    />
  );
};

export const DeleteButton = withHighlight(memo(DeleteBtn), EventsBinding.DELETE_RECORDING);
